import { useNavigate } from "react-router-dom";
import { haptic } from "../lib/telegram";

export type IconColor =
  | "blue" | "purple" | "green" | "orange" | "pink"
  | "teal" | "indigo" | "yellow" | "red" | "mint" | "brown";

interface Props {
  to: string;
  icon: string;
  title: string;
  subtitle: string;
  color?: IconColor;
}

const iconColorClasses: Record<IconColor, string> = {
  blue: "bg-[var(--icon-blue-bg)] text-[var(--icon-blue)]",
  purple: "bg-[var(--icon-purple-bg)] text-[var(--icon-purple)]",
  green: "bg-[var(--icon-green-bg)] text-[var(--icon-green)]",
  orange: "bg-[var(--icon-orange-bg)] text-[var(--icon-orange)]",
  pink: "bg-[var(--icon-pink-bg)] text-[var(--icon-pink)]",
  teal: "bg-[var(--icon-teal-bg)] text-[var(--icon-teal)]",
  indigo: "bg-[var(--icon-indigo-bg)] text-[var(--icon-indigo)]",
  yellow: "bg-[var(--icon-yellow-bg)] text-[var(--icon-yellow)]",
  red: "bg-[var(--icon-red-bg)] text-[var(--icon-red)]",
  mint: "bg-[var(--icon-mint-bg)] text-[var(--icon-mint)]",
  brown: "bg-[var(--icon-brown-bg)] text-[var(--icon-brown)]",
};

export function ServiceCard({ to, icon, title, subtitle, color = "blue" }: Props) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="ios-row w-full text-left ios-card-press"
      onClick={() => {
        haptic("light");
        navigate(to);
      }}
    >
      <div className={`icon-tile ${iconColorClasses[color]}`}>{icon}</div>
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-ink text-[15px] leading-tight">{title}</div>
        <div className="text-[13px] text-muted mt-0.5 leading-snug truncate">{subtitle}</div>
      </div>
      <div className="text-muted text-lg leading-none">›</div>
    </button>
  );
}
